<template>
  <v-card :style="backOpacity">
    <v-card-title v-if="returnData.type == 28">メール件名</v-card-title>
    <v-card-title v-if="returnData.type == 29">メール本文</v-card-title>
    <v-card-title v-if="returnData.type == 11"
      >テキストエリア(プラスボタン付き) {{ title }}</v-card-title
    >
    <v-card-title v-else-if="returnData.type == 8"
      >テキストエリア(複数行) {{ title }}</v-card-title
    >
    <v-card-title v-else>テキストエリア {{ title }}</v-card-title>
    <v-card-text>
      <v-container>
        rules.length:{{ rules.length }} <br />
        rules:{{ rules }}
        <v-row>
          <v-col cols="auto">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
              hint="{{}}で囲うとhint表示"
            ></v-text-field>
          </v-col>
          <!-- cols -->
          <v-col cols="3">
            <set-Cols
              :value="String(returnData.cols)"
              v-on:set="$set(returnData, 'cols', $event)"
            ></set-Cols>
          </v-col>
          <v-col cols="3">
            <set-css
              :params="String(returnData.css)"
              v-on:set="$set(returnData, 'css', $event)"
            ></set-css>
          </v-col>
          <!--- ----->
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="初期値"
                  v-model="returnData.init"
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <span>
                {formID}で対象IDの初期値が入る<br />
                <div v-if="returnData.type == 11">
                  カンマ(,)区切りで値が格納される<br />
                  ,区切りで複数初期値<br />
                  ,だけなら空白
                </div>
              </span>
            </v-tooltip>
          </v-col>
          <v-col v-if="returnData.type == 1 || returnData.type == 8" cols="3">
            <v-checkbox
              v-model="rules[2]"
              label="入力不可"
              value="required"
            ></v-checkbox>
          </v-col>
          <v-col v-if="returnData.type == 11" cols="3">
            <v-checkbox
              v-model="rules[5]"
              label="縦に並べる(1行専有)"
              :disabled="rules[2] == 'LeftJoin'"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col v-if="returnData.type == 11" cols="3">
            <v-checkbox
              v-model="rules[2]"
              label="左隣のプラスボタンと連結"
              :disabled="rules[5] == 'true'"
              value="LeftJoin"
            ></v-checkbox>
          </v-col>
          <v-col v-if="returnData.type == 1 || returnData.type == 8" cols="3">
            <v-checkbox
              v-model="rules[5]"
              label="非表示(ボタン透明化)"
              value="hide"
            ></v-checkbox>
          </v-col>
          <v-col v-if="returnData.type == 8 || returnData.type == 29" cols="3">
            <v-text-field
              label="行数(テキストエリア)"
              v-model="returnData.size"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <p>バリデーション</p>
          <v-col cols="2">
            <v-checkbox
              v-model="validations[0]"
              label="空値不可"
              value="required"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[1]"
              label="超える"
              value="moreThan"
            ></v-checkbox>
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[2]"
              label="以上"
              value="orMore"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[3]"
              label="未満"
              value="lessThan"
            ></v-checkbox>
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[4]"
              label="以下"
              value="orLess"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[5]"
              label="等しい"
              value="equal"
            ></v-checkbox>
            <v-checkbox
              v-if="returnData.type != 11"
              v-model="validations[6]"
              label="等しくない"
              value="notEqual"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group
              v-if="validations[1] != null"
              label="超える:バリデーション詳細"
              v-model="validationDetails[1]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[1]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-radio-group
              v-if="validations[2] != null"
              label="以上：バリデーション詳細"
              v-model="validationDetails[2]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[2]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-radio-group
              v-if="validations[3] != null"
              label="未満:バリデーション詳細"
              v-model="validationDetails[3]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[3]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-radio-group
              v-if="validations[4] != null"
              label="以下:バリデーション詳細"
              v-model="validationDetails[4]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[4]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-radio-group
              v-if="validations[5] != null"
              label="等しい:バリデーション詳細"
              v-model="validationDetails[5]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[5]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-radio-group
              v-if="validations[6] != null"
              label="等しくない：バリデーション詳細"
              v-model="validationDetails[6]"
              class="ma-2"
            >
              <v-radio label="固定値" value="const"></v-radio>
              <v-radio label="特定フォームの値" value="formId"></v-radio>
              <v-text-field
                label="値 or formID"
                v-model="validationNums[6]"
                required
              ></v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-checkbox
              v-model="limitValidationFlag[0]"
              label="特定権限時のバリデーション"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="3" v-if="limitValidationFlag == 'true'">
            <v-checkbox
              v-model="targetJob[0]"
              label="管理者以外へ付与"
              value="admin"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="3"
            v-if="limitValidationFlag[0] != null && targetJob[0] != null"
          >
            <v-checkbox
              v-model="limitValidation[0]"
              label="空値許可"
              value="allowNull"
            ></v-checkbox>
          </v-col>
        </v-row>
        <p>
          上のバリデーションが1つだけかつ、対象の値が特定フォームの値の時のみ現在使用可能です
        </p>
        <v-row>
          <v-col cols="6">
            <v-radio-group label="ルール" v-model="rules[1]" row>
              <v-radio label="全て" value="0"></v-radio>
              <v-radio label="全て(テンキー)" value="10"></v-radio>
              <v-radio label="全て(英数半角のみ)" value="11"></v-radio>
              <v-radio label="全て(英数全角のみ)" value="12"></v-radio>
              <v-radio label="整数のみ" value="1"></v-radio>
              <v-radio label="1以上" value="4"></v-radio>
              <v-radio label="数値(小数点含む)" value="5"></v-radio>
              <v-radio label="数値(小数点,マイナス含む)" value="7"></v-radio>
              <v-radio label="英数字のみ" value="2"></v-radio>
              <v-radio label="メールアドレス" value="3"></v-radio>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-radio
                    label="日付+時間"
                    value="6"
                    v-bind="attrs"
                    v-on="on"
                  ></v-radio>
                </template>
                <span>入力はカレンダー→時計が表示されます</span>
              </v-tooltip>
              <v-tooltip top v-if="false">
                <!-- フロント側・生成ロジックが未完成 -->
                <template v-slot:activator="{ on, attrs }">
                  <v-radio
                    label="日付+時間(小型)"
                    value="13"
                    v-bind="attrs"
                    v-on="on"
                  ></v-radio>
                </template>
                <span>カレンダー→時計の小型版 </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-radio
                    label="日付+時間(時刻変更のみ)"
                    value="8"
                    v-bind="attrs"
                    v-on="on"
                  ></v-radio>
                </template>
                <span>入力は時計のみが表示されます</span>
              </v-tooltip>
              <v-radio label="日付+時間(秒数表示なし)" value="9"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            cols="2"
            v-if="
              rules[1] == '1' ||
                rules[1] == '2' ||
                rules[1] == '4' ||
                rules[1] == '5' ||
                rules[1] == '7'
            "
          >
            <v-select
              label="追加バリデーションルール"
              v-model="rules14A"
              item-text="text"
              item-value="value"
              :items="validationlist"
              :rules="[]"
            ></v-select>
            <v-text-field
              label="追加オプション"
              v-model="rules14B"
              outlined
              :rules="[validation.numOnly]"
            ></v-text-field
          ></v-col>
          <v-col v-if="rules[1] == '6' || rules[1] == '13'">
            <v-checkbox
              v-model="rules[20]"
              label="デフォルト値無し"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row
          v-if="
            rules[1] == '1' ||
              rules[1] == '4' ||
              rules[1] == '5' ||
              rules[1] == '10'
          "
        >
          <v-col cols="2">
            <v-checkbox
              label="手入力可"
              v-model="rules[16]"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="オリジナルキーパッド名"
              v-model="rules[17]"
              outlined
              :rules="[validation.fileName]"
            ></v-text-field>
          </v-col>
          <v-col>
            改良したキーパッドのファイルは直接githubに入れてください。名前はファイル名と同一で二単語以上、二単語目の最初を大文字にしてください。(例:originalKeypad)
          </v-col>
        </v-row>
        <hr class="mb-2" />
        <v-row>
          <v-col>
            <v-checkbox
              label="オリジナルバリデーション"
              v-model="rules18Flag"
            ></v-checkbox>
          </v-col>
          <v-col v-if="rules18Flag">
            <v-text-field
              label="オリジナルバリデーション"
              v-model="rules[18]"
              outlined
              :rules="[]"
            ></v-text-field>
          </v-col>
          <v-col v-if="rules18Flag">
            <v-text-field
              label="オリジナルメッセージ"
              v-model="rules[19]"
              outlined
              :rules="[]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="returnData.type != 8 && returnData.type != 11">
          <v-col cols="4">
            <v-checkbox
              v-model="rules[3]"
              label="特定フォームの値を表示"
              value="required"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-btn v-if="rules[3] == 'required'" @click="add" class="ma-3"
              >追加</v-btn
            >
          </v-col>
          <v-col cols="2">
            <v-btn v-if="rules[3] == 'required'" @click="del" class="ma-3"
              >削除</v-btn
            >
          </v-col>
          <v-col>
            <p v-if="rules[4] == 'total' || rules[4] == 'totalSum'">
              formID1に合計対象のFormID <br />
              formID2にページ内のサブページformID
            </p>
          </v-col>
        </v-row>
        <v-row v-if="rules[3] == 'required'">
          <v-col v-for="(v, i) in values" :key="i" cols="2">
            <!--<v-text-field
              :label="'formID ' + (i + 1)"
              v-model="values[i]"
              required
              outlined
            ></v-text-field>-->
            <search-Page
              :label="'formID ' + (i + 1)"
              v-model="values[i]"
            ></search-Page>
          </v-col>
        </v-row>
        <v-row v-if="rules[3] == 'required' && values.length < 2" rows="12">
          <v-col cols="12">
            <v-radio-group label="計算方式" v-model="rules[4]" row>
              <v-radio label="表示" value=""> </v-radio>
              <v-radio label="プラスボタンの合計" value="pulstotal"> </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="rules[3] == 'required' && values.length > 1" rows="12">
          <v-col cols="12">
            <v-radio-group label="計算方式" v-model="rules[4]" row>
              <v-radio
                label="結合"
                value="join"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="結合時、特定文字を挟む"
                value="joinInsert"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio label="テスト" value="test"></v-radio>
              <v-radio label="合計(id1+id...)" value="plus"></v-radio>
              <v-radio label="最小(id1+id...)" value="min"></v-radio>
              <v-radio label="最大(id1+id...)" value="max"></v-radio>
              <v-radio label="平均(id1+id...)" value="average"></v-radio>
              <v-radio
                label="減算(id1-id...)"
                value="sub"
                v-if="values.length > 2"
              ></v-radio>
              <v-radio
                label="掛け算(id1*id*{固定値})"
                value="mult"
                v-if="values.length > 2"
              ></v-radio>
              <v-radio
                label="日付(id1)-数値(id-id...)=差分"
                value="DaySub"
                v-if="values.length > 2"
              ></v-radio>
              <v-radio
                label="日付(id1)+数値(id+id...)=和分"
                value="DayAdd"
                v-if="values.length > 2"
              ></v-radio>
              <v-radio
                v-if="values.length > 2"
                label="特定の値が入力されているフォームの合計数"
                value="targetCount"
              ></v-radio>
              <v-radio
                label="減算(id1-id2)"
                value="sub"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="乗算(id1*id2)"
                value="mult"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="除算(id1/id2*100)"
                value="div"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="日付(id1-id2)=時間"
                value="dateSub"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="時間(id1-id2)=時間"
                value="timeSub"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="時間(id1-id2)=分"
                value="minuteSub"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="時間(id1+id2)=時間"
                value="timeAdd"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="稼働率(100-(id1/id2*100))"
                value="operating"
                v-if="values.length == 2"
              ></v-radio>
              <v-radio
                label="月日(id1)+時間(id2)=日付変換"
                value="DayTime"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="日付(id1)-日数(id2)=日付変換"
                value="DaySub"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="日付(id1)+日数(id2)=日付変換"
                value="DayAdd"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="サブページの時間合計"
                value="total"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="サブページの数値合計"
                value="totalSum"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="サブページをカウント"
                value="totalSubPage"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="プラスボタンの合計"
                value="pulstotal"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-radio
                label="日付+日数=日付"
                value="dateAdd"
                v-if="values.length == 2"
              >
              </v-radio>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-radio
                    label="サブページの特定フォームの個別表示"
                    value="subPageValues"
                    v-if="values.length == 2"
                    v-bind="attrs"
                    v-on="on"
                  ></v-radio>
                </template>
                <span
                  >v-forでサブページの名前毎に表示される,formID1に個別表示するFormID,
                  formID2にページ内のサブページformID,*必ず行の先頭に配置</span
                >
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-radio
                    label="サブページの特定フォームを連結表示"
                    value="subPageTargetValue"
                    v-bind="attrs"
                    v-on="on"
                    v-if="values.length == 2"
                  ></v-radio>
                </template>
                <span
                  >formID1に個別表示するFormID,formID2にページ内のサブページformID</span
                >
              </v-tooltip>
            </v-radio-group>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-if="rules[4] == 'targetCount'"
              label="特定の値"
              outlined
              :rules="[]"
              v-model="rules[27]"
            ></v-text-field>
          </v-col>
          <v-col cols="2" v-if="rules[4] == 'joinInsert'">
            <v-text-field
              label="挿入文字列"
              v-model="rules[15]"
              outlined
              :rules="[validation.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="2" v-if="rules[4] == 'dateSub'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="削除対象時間"
                  v-model="rules[21]"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[validation.required]"
                ></v-text-field>
              </template>
              <span
                >使用しない場合は空。指定方法は「12:00:00~13:00:00」のように全て半角で指定してください。id1とid2で日付が異なる場合には未対応</span
              >
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          v-if="
            rules[3] == 'required' &&
              values.length > 1 &&
              (rules[4] == 'totalSum' || rules[4] == 'subPageValues')
          "
          rows="12"
        >
          <v-col cols="4">
            <v-checkbox
              v-model="targetSubPageFlag"
              label="特定条件のサブページのみ集計"
              value="true"
            ></v-checkbox>
            **IF条件が1個目でXの指定がない場合は対象サブページIDでグループ化
            (サブページ特定フォーム個別表示との組み合わせ前提)
          </v-col>
          <v-col cols="4" v-if="targetSubPageFlag">
            <v-text-field
              label="IF条件(サブページ内のフォームID) :追加分割条件"
              v-model="rules[8]"
              :rules="[validation.numANDcolon]"
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="targetSubPageFlag">
            <v-text-field label="if == X" v-model="rules[9]"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="returnData.type == 11">
          <v-col cols="3">
            <v-text-field
              label="アイコンのサイズ"
              v-model="values[0]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="bottom調整"
              v-model="values[1]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="rules[11]"
              label="特定フォーム2つの値と一致する値を自身に代入"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
        <p v-if="rules[11] == 'true'">
          想定している値は1番目のformIDはテキストフィールドなどの値が1つに決まるもの。
          2つ目はラジオボタンなど値が切り替わるもの。
          pageIDから何番目というのは一番左を0から数えた場合です。
          決める文字列とは例としてラジオボタンの値がa,
          bの選択肢があればaとbが決める文字列になります。
        </p>
        <v-row>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="検索データを作成するページID"
              v-model="searchPageID"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="1番目の検索対象のformID"
              v-model="firstFormID"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="1番目のformIDはpageIDの中の何番目に含むか"
              v-model="firstColumn"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="2番目の検索対象のformID"
              v-model="secondFormID"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="2番目のformIDはpageIDの中の何番目か(1つ目)"
              v-model="secondColumn1"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="2番目のformIDの値を決める文字列(1つ目)"
              v-model="secondValue1"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="2番目のformIDはpageIDの中の何番目か(2つ目)"
              v-model="secondColumn2"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="rules[11] == 'true'">
            <v-text-field
              label="2番目のformIDの値を決める文字列(2つ目)"
              v-model="secondValue2"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="returnData.type != 8 && returnData.type != 11">
          <v-col cols="4">
            <v-checkbox
              v-model="if_disableFlag"
              label="入力可・不可の切り替え"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="4" v-if="if_disableFlag">
            <v-text-field
              label="IF条件フォームID"
              v-model="rules[6]"
              :rules="[validation.numOnly]"
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="if_disableFlag">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="if == X(コロン[:]区切り)"
                  :rules="[validation.numANDcolonANDaANDnull]"
                  v-model="rules[7]"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <span>
                *1 空なら対象フォームIDのdisabledと連動<br />
                *2-1 {}で囲むとX文字列を含む場合<br />
                *2-2 ■入力不可にチェックありだと if != Xを満たす時入力可<br />
                *2-3 ■「null」なら""で判定
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="rules13Flag"
              label="他の二つの値が特定の条件の時に入力可"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules13Flag"
              label="一つ目のformID"
              v-model="rules13firstID"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules13Flag"
              label="二つ目のformID"
              v-model="rules13secondID"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-select
              :items="terms"
              v-if="rules13Flag"
              item-text="label"
              item-value="value"
              v-model="rules13term"
              label="条件"
            ></v-select
          ></v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-checkbox
              v-model="rules26Flag"
              label="追加ユーザフォームの特定の値で入力可不可切り替え"
            ></v-checkbox>
          </v-col>
          <v-col cols="2" v-if="rules26Flag">
            <search-Page
              label="対象formID"
              v-model.number="rules26formID"
              required
            ></search-Page>
          </v-col>
          <v-col cols="3" v-if="rules26Flag">
            <v-text-field
              label="指定の値"
              v-model="rules26value"
              hint="先頭に!を付けると!=として判定します"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="rules22Flag"
              label="サブページの特定の最新の値を表示"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules22Flag"
              label="サブページformID"
              v-model="rules22subFormID"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules22Flag"
              label="サブページ内の比較formID"
              hint="指定したformには【日時】がある前提です"
              v-model="rules22compareFormID"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules22Flag"
              label="サブページ内の表示formID"
              hint="最新の値のみ表示されます"
              v-model="rules22showFormID"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="expFlag"
              label="正規表現を用いた成形フォーマット(開発中)"
            ></v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-if="expFlag"
              label="正規表現を入力"
              v-model="rules[12]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="rules23Flag"
              label="親ページのフォームの値を取得"
            ></v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-if="rules23Flag"
              label="親ページのformID"
              v-model="rules[23]"
              required
              outlined
              :rules="[validation.numOnly]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-checkbox
              v-model="rules24Flag"
              label="基準値を超えた場合、背景色変更"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-if="rules24Flag"
              label="基準値"
              v-model="rules24limit"
              hint="「基準値の間」の時はコロン区切りで2つ値を指定してください"
              required
              outlined
              :rules="[]"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-radio-group row v-if="rules24Flag" v-model="rules24option">
              <v-radio label="以下" value="<="></v-radio>
              <v-radio label="以上" value=">="></v-radio>
              <v-radio label="基準値の間(X<=□<=Y)" value="<=>="></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="this.$store.state.colors"
              v-if="rules24Flag"
              v-model="rules24color"
              label="背景色"
              :background-color="rules24color"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="rules24Flag">
          <v-col cols="3">
            <v-checkbox
              v-model="rules25Flag"
              label="基準値を超えた場合、hint表示"
            ></v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-if="rules25Flag"
              label="表示文言"
              v-model="rules25message"
              required
              outlined
              :rules="[]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="rules28Flag"
              label="値更新時に特定処理を実行"
            ></v-checkbox>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-if="rules28Flag"
              label="@chageに入れる値"
              v-model="rules[28]"
              required
              outlined
              :rules="[]"
              hint=""
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
import setCss from "../CSSparam/setCssParam.vue";
import searchPage from "./common/searchPage.vue";
export default {
  props: {
    label: String,
    init: String,
    type: Number,
    position: Number,
    cols: String,
    size: Number,
    rule: String, //[0:空値不可,1:バリデーションルール,2:入力不可,3:特定フォームの値,4:計算式,5:非表示オプション]
    value: String, //計算にしているフォームIDの値 //((プラスボタン付き)+-ボタンの大きさと位置
    css: { type: String, default: "" },
  },
  components: {
    setCols,
    searchPage,
    setCss,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        position: this.position,
        cols: this.cols,
        size: this.size,
        rule: this.rule,
        value: this.value,
        css: this.css,
      },
      validations: [],
      validationDetails: [
        null,
        "const",
        "const",
        "const",
        "const",
        "const",
        "const",
      ],
      validationlist: [
        { text: "指定なし", value: "" },
        { text: "桁数指定", value: "digitSpecification" },
        { text: "小数点以下0~X桁まで", value: "decimalPlaces" },
        { text: "小数点以下X桁固定", value: "decimalPlacesForce" },
        { text: "n倍限定", value: "Xtimeslimited" },
      ],
      terms: [
        { label: "一致", value: "equal" },
        { label: "不一致", value: "notEqual" },
      ],
      title: "TextForm.vue",
      backOpacity: "opacity: 1",
      showButton: false,
      validationNums: [],
      limitValidationFlag: [],
      targetJob: [],
      limitValidation: [],
      rules: [],
      values: [0, 0],
      searchPageID: "",
      firstFormID: "",
      firstColumn: "",
      secondFormID: "",
      secondValue1: "",
      secondValue2: "",
      secondColumn1: "",
      secondColumn2: "",
      rules13firstID: "",
      rules13secondID: "",
      rules13term: "",
      rules22subFormID: "",
      rules22compareFormID: "",
      rules22showFormID: "",
      rules24limit: "",
      rules24option: "<=",
      rules24color: "yellow lighten-2",
      rules25message: "基準値を満たしていません",
      rules26formID: "",
      rules26value: "",
      //フラグ関連
      if_disableFlag: false,
      targetSubPageFlag: false,
      expFlag: false,
      rules13Flag: false,
      rules18Flag: false,
      rules22Flag: false,
      rules23Flag: false,
      rules24Flag: false,
      rules25Flag: false,
      rules26Flag: false,
      rules28Flag: false,
      rules14A: "",
      rules14B: "",

      //
      valid: true,
      validation: {
        numOnly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numANDcolon: (value) => {
          return /^[0-9:]*$/.test(value) || "数値コロンのみ";
        },
        numANDcolonANDaANDnull: (value) => {
          return (
            /^[0-9:{}}]*(null)?$/.test(value) || "数値,コロン,{},!,nullのみ"
          );
        },
        fileName: (value) => {
          return (
            /^[a-z]{3}[a-z0-9]*[A-Z][a-zA-Z0-9]*$/.test(value) ||
            "先頭a-z3文字以上 大文字必須 英字のみ"
          );
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        notuseComma: (value) => {
          return value == null
            ? false
            : ~value.indexOf(",")
            ? "カンマは\\tで代用してください"
            : true;
        },
      },
    };
  },
  mounted() {
    //送信ボタンのカクツキ防止
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    this.rules = this.rule.split(",");
    this.values = this.value.split(",");
    // バリデーション条件分解処理
    [
      this.validations,
      this.validationDetails,
      this.validationNums,
    ] = this.initValidation(this.rules[0].split(":"));

    if (this.type == 28 || this.type == 29) {
      this.validations[0] = "required";
    }

    if (typeof this.rules[10] != "undefined") {
      //「特定権限時のバリデーション」分解処理
      [
        this.limitValidationFlag,
        this.targetJob,
        this.limitValidation,
      ] = this.initLimitValidation(this.rules[10].split("."));
    }

    if (typeof this.rules[11] != "undefined") {
      //「特定フォーム2つの値と一致した値を代入」分解処理
      [
        this.rules[11],
        this.searchPageID,
        this.firstFormID,
        this.firstColumn,
        this.secondFormID,
        this.secondColumn1,
        this.secondValue1,
        this.secondColumn2,
        this.secondValue2,
      ] = this.rules[11].split(".");
    }

    if (this.rules[6] != null && this.rules[6] != "") {
      this.if_disableFlag = "true";
    }
    if (this.rules[8] != null && this.rules[8] != "") {
      this.targetSubPageFlag = "true";
    }
    if (this.rules[12] != null && this.rules[12] != "") {
      this.expFlag = true;
    }
    if (this.rules[13] != null && this.rules[13] != "") {
      this.rules13Flag = "true";
      [
        this.rules13firstID,
        this.rules13secondID,
        this.rules13term,
      ] = this.rules[13].split(".");
    }
    if (this.rules[14] != null && this.rules[14] != "") {
      [this.rules14A, this.rules14B] = this.rules[14].split(":");
    }
    if (this.rules[18] != null && this.rules[18] != "") {
      this.rules18Flag = true;
    }
    if (this.rules[22] != null && this.rules[22] != "") {
      this.rules22Flag = true;
      [
        this.rules22subFormID,
        this.rules22compareFormID,
        this.rules22showFormID,
      ] = this.rules[22].split(".");
    }
    if (this.rules[23] != null && this.rules[23] != "") {
      this.rules23Flag = true;
    }
    if (this.rules[24] != null && this.rules[24] != "") {
      this.rules24Flag = true;
      if (this.rules[24].includes("|")) {
        [
          this.rules24limit,
          this.rules24option,
          this.rules24color,
        ] = this.rules[24].split("|");
      } else {
        [
          this.rules24limit,
          this.rules24option,
          this.rules24color,
        ] = this.rules[24].split(".");
      }
    }
    if (this.rules[25] != null && this.rules[25] != "") {
      this.rules25Flag = true;
      this.rules25message = this.rules[25];
    }
    if (this.rules[26] != null && this.rules[26] != "") {
      this.rules26Flag = true;
      [this.rules26formID, this.rules26value] = this.rules[26].split(".");
    }
    if (this.rules[28] != null && this.rules[28] != "") {
      this.rules[28] = this.rules[28].replace("\t", ",");
      this.rules28Flag = true;
    }
  },
  methods: {
    submit() {
      let validationJoin = "";

      for (let i = 0; i < this.validations.length; i++) {
        if (this.validations[i] != null) {
          validationJoin += this.validations[i];
        }
        if (this.validations[i] != null && this.validationDetails[i] != null) {
          validationJoin += "." + this.validationDetails[i];
        }
        if (this.validations[i] != null && this.validationNums[i] != null) {
          validationJoin += "." + this.validationNums[i];
        }
        if (this.validations[i] != null) {
          validationJoin += ":";
        }
      }
      // 必ず最後に : が付くため除去
      validationJoin = validationJoin.slice(0, -1);
      this.rules[0] = validationJoin;

      // rules[10]limitValidation結合処理
      // TODO:limitValidationが複数の場合の処理はまだ無し
      if (
        this.limitValidationFlag != "" &&
        this.targetJob != "" &&
        this.limitValidation != ""
      ) {
        this.rules[10] =
          this.limitValidationFlag +
          "." +
          this.targetJob +
          "." +
          this.limitValidation;
      } else {
        this.rules[10] = "";
      }

      //rules[11]「特定フォーム2つの値と一致した値を代入」結合処理
      if (this.rules[11] == "true") {
        this.rules[11] += "." + this.searchPageID;
        this.rules[11] += "." + this.firstFormID;
        this.rules[11] += "." + this.firstColumn;
        this.rules[11] += "." + this.secondFormID;
        this.rules[11] += "." + this.secondColumn1;
        this.rules[11] += "." + this.secondValue1;
        this.rules[11] += "." + this.secondColumn2;
        this.rules[11] += "." + this.secondValue2;
      }

      if (this.returnData.type == 11) {
        this.returnData.value = this.values.join(",");
      } else if (this.rules[3] != "required") {
        this.values = [0, 0];
      }
      if (!this.if_disableFlag) {
        this.rules[6] = null;
        this.rules[7] = null;
      }
      if (!this.targetSubPageFlag) {
        this.rules[8] = null;
        this.rules[9] = null;
      }
      if (!this.expFlag) {
        this.rules[12] = null;
      }
      if (this.rules13Flag == "true") {
        this.rules[13] =
          this.rules13firstID +
          "." +
          this.rules13secondID +
          "." +
          this.rules13term;
      } else {
        this.rules[13] = "";
      }
      if (this.rules14A != "" && this.rules14B != "") {
        if (
          this.rules[1] == "1" ||
          this.rules[1] == "2" ||
          this.rules[1] == "4" ||
          this.rules[1] == "5" ||
          this.rules[1] == "7"
        ) {
          this.rules[14] = this.rules14A + ":" + this.rules14B;
        } else {
          this.rules[14] = "";
        }
      } else {
        this.rules[14] = "";
      }
      if (this.rules18Flag == false) {
        this.rules[18] = "";
        this.rules[19] = "";
      }
      if (this.rules22Flag) {
        this.rules[22] =
          this.rules22subFormID +
          "." +
          this.rules22compareFormID +
          "." +
          this.rules22showFormID;
      } else {
        this.rules[22] = "";
      }
      if (!this.rules23Flag) {
        this.rules[23] = "";
      }
      if (this.rules24Flag) {
        this.rules[24] =
          this.rules24limit +
          "|" +
          this.rules24option +
          "|" +
          this.rules24color;
      } else {
        this.rules[24] = "";
      }
      //rules24の条件式を利用するため
      if (this.rules24Flag && this.rules25Flag) {
        this.rules[25] = this.rules25message;
      } else {
        this.rules[25] = "";
      }
      if (this.rules26Flag) {
        this.rules[26] = this.rules26formID + "." + this.rules26value;
      } else {
        this.rules[26] = "";
      }
      if (!this.rules28Flag) {
        this.rules[28] = "";
      } else {
        this.rules[28] = this.rules[28].replace(",", "\t");
      }
      //-----------------------------------------
      this.returnData.rule = this.rules.join(",");
      this.returnData.value = this.values.join(",");
      this.$emit("clickSubmit", this.returnData);
    },
    add() {
      if (this.values.length < 30) {
        this.values.push(0);
        if (this.values.length == 2) {
          this.rules[4] = "join";
        }
      }
    },
    del() {
      if (this.values.length > 1) {
        this.values.splice(-1, 1);
      }
    },
    initValidation(intoValidations) {
      const arrValidation = [];
      const arrValidationDetail = [];
      const arrValidationNums = [];
      for (let i = 0; i < intoValidations.length; i++) {
        const splitValidation = intoValidations[i].split(".");
        // 決まった番地に値が入るため値に応じて番地を決定
        switch (splitValidation[0]) {
          case "required":
            arrValidation[0] = splitValidation[0];
            break;
          case "moreThan":
            arrValidation[1] = splitValidation[0];
            break;
          case "orMore":
            arrValidation[2] = splitValidation[0];
            break;
          case "lessThan":
            arrValidation[3] = splitValidation[0];
            break;
          case "orLess":
            arrValidation[4] = splitValidation[0];
            break;
          case "equal":
            arrValidation[5] = splitValidation[0];
            break;
          case "notEqual":
            arrValidation[6] = splitValidation[0];
            break;
        }

        if (splitValidation.length > 1) {
          switch (splitValidation[0]) {
            case "required":
              arrValidationDetail[0] = splitValidation[1];
              arrValidationNums[0] = splitValidation[2];
              break;
            case "moreThan":
              arrValidationDetail[1] = splitValidation[1];
              arrValidationNums[1] = splitValidation[2];
              break;
            case "orMore":
              arrValidationDetail[2] = splitValidation[1];
              arrValidationNums[2] = splitValidation[2];
              break;
            case "lessThan":
              arrValidationDetail[3] = splitValidation[1];
              arrValidationNums[3] = splitValidation[2];
              break;
            case "orLess":
              arrValidationDetail[4] = splitValidation[1];
              arrValidationNums[4] = splitValidation[2];
              break;
            case "equal":
              arrValidationDetail[5] = splitValidation[1];
              arrValidationNums[5] = splitValidation[2];
              break;
            case "notEqual":
              arrValidationDetail[6] = splitValidation[1];
              arrValidationNums[6] = splitValidation[2];
              break;
          }
        }
      }

      return [arrValidation, arrValidationDetail, arrValidationNums];
    },
    // TODO:複数のバリデーションの制御不可
    initLimitValidation(limitValidations) {
      const limitValidationFlag = [];
      const targetJob = [];
      const limitValidation = [];

      if (limitValidations.length > 0) {
        limitValidationFlag[0] = limitValidations[0];
        targetJob[0] = limitValidations[1];
        limitValidation[0] = limitValidations[2];
      } else {
        limitValidationFlag[0] = null;
        targetJob[0] = null;
        limitValidation[0] = null;
      }

      return [limitValidationFlag, targetJob, limitValidation];
    },
  },
};
</script>
